import type { ReactNode } from "react";
import { Show } from "shared/components";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { cx } from "shared/utils";

export const PERMISSION_DENIED_SWITCH_CLASS_NAME =
  "opacity-40 cursor-not-allowed";

export const PermissionDeniedTooltip = ({
  tooltip,
  children,
  className
}: {
  tooltip?: string | null;
  children: ReactNode;
  className?: string;
}) => (
  <Tooltip placement="top-start">
    <TooltipTrigger asChild>
      <div className={cx("w-fit", className)}>{children}</div>
    </TooltipTrigger>
    <Show if={Boolean(tooltip)}>
      <TooltipContent className="max-w-[370px] rounded-lg z-[50] border bg-alpha-800 p-4 text-sm text-content-1000-inverted">
        <p>{tooltip}</p>
      </TooltipContent>
    </Show>
  </Tooltip>
);
